// extracted by mini-css-extract-plugin
export default {"component":"QTWnlT","mobile":"ZiLLC9","content":"vf3J1D"};